// \u00A0

import React from 'react';
import { styled } from 'linaria/react';
import { Link } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSText;
const Ul = withTheme(/*#__PURE__*/styled('ul')({
  name: "Ul",
  class: "umtodwp",
  propsAsIs: false,
  vars: {
    "umtodwp-0": [_exp5()],
    "umtodwp-1": [_exp2(), "px"],
    "umtodwp-2": [_exp3()],
    "umtodwp-3": [_exp4(), "px"]
  }
}));
const _exp6 = /*#__PURE__*/() => Link;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primaryLink;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.primaryLinkHover;
const NewCardLink = withTheme(/*#__PURE__*/styled(_exp6())({
  name: "NewCardLink",
  class: "nlp8p2c",
  propsAsIs: true,
  vars: {
    "nlp8p2c-0": [_exp7()],
    "nlp8p2c-1": [_exp8()]
  }
}));
export const newYearFaqData = [{
  title: <>Где можно прочитать полные условия розыгрыша?</>,
  text: <>
        Полные условия доступны по&nbsp;
        <NewCardLink href="https://staticpayment.ssl.mts.ru/upload/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0_%D0%B0%D0%BA%D1%86%D0%B8%D0%B8_%D0%97%D0%B8%D0%BC%D0%BD%D0%B8%D0%B8%CC%86_%D1%80%D0%BE%D0%B7%D1%8B%D0%B3%D1%80%D1%8B%D1%88_%D0%BF%D1%80%D0%B8%D0%B7%D0%BE%D0%B2_%D0%BD%D0%B0_Steam__%D0%94%D0%9F_.pdf">
          ссылке
        </NewCardLink>
      </>
}, {
  title: <>Кто может участвовать?</>,
  text: <>Любой гражданин РФ&nbsp;или иностранный гражданин, постоянно проживающий в&nbsp;России, достигший 18 лет</>
}, {
  title: <>Какой период проведения акции?</>,
  text: <>
        Акция проходит с&nbsp;18 декабря 2025 по&nbsp;31 января 2026 включительно по&nbsp;московскому времени.
        Участвовать и&nbsp;совершать платежи можно с&nbsp;18 декабря 2025 по&nbsp;5 января 2026
      </>
}, {
  title: <>Что нужно сделать, чтобы участвовать?</>,
  text: <Ul>
        <li>Подтвердить участие на&nbsp;сайте МТС Оплата, нажав кнопку &laquo;Принять участие&raquo;</li>
        <li>
          Минимум 3 раза пополнить Steam через сервис МТС Оплата в&nbsp;период с&nbsp;18 декабря 2025 по&nbsp;5 января
          2026
        </li>
      </Ul>
}, {
  title: <>Как выбираются победители?</>,
  text: <>
        Есть две категории победителей:
        <Spacer />
        Категория 1 — по активности <br />
        Главные призы получают 3 участника, совершившие больше всего пополнений Steam: <br />
        <Ul>
          <li>1 место — максимальное число платежей</li>
          <li>2 место — следующий по количеству платежей</li>
          <li>3 место — третий по количеству</li>
        </Ul>
        <Spacer />
        Категория 2 — случайный выбор <br />
        Среди всех участников, совершивших минимум 3 платежа, определяется 850 получателей дополнительных призов
        с&nbsp;помощью генератора случайных чисел
      </>
}, {
  title: <>Сколько победителей всего?</>,
  text: <>
        Всего 853 победителя:
        <br />
        <Ul>
          <li>3 человека — главные призы</li>
          <li>850 человек — дополнительные призы</li>
        </Ul>
      </>
}, {
  title: <>Какие призы можно выиграть?</>,
  text: <>
        Главные призы: <br />
        <Ul>
          <li>🥇 1 место — 100 000 рублей на аккаунт Steam</li>
          <li>🥈 2 место — 50 000 рублей на аккаунт Steam</li>
          <li>🥉 3 место — 25 000 рублей на аккаунт Steam</li>
        </Ul>
        <Spacer />
        Дополнительные призы: <br />
        <Ul>
          <li>850 победителей получают по 1 000 рублей на аккаунт Steam</li>
        </Ul>
      </>
}, {
  title: <>Можно&nbsp;ли обменять приз на&nbsp;деньги или что-то другое?</>,
  text: <>Нет. Призы не&nbsp;обмениваются на&nbsp;деньги и&nbsp;не&nbsp;заменяются другими</>
}, {
  title: <>До какого срока начислят призы?</>,
  text: <>Все призы будут начислены до&nbsp;31 января 2026 года</>
}, {
  title: <>Где можно посмотреть список победителей?</>,
  text: <>
        Список участников, номера для розыгрыша и&nbsp;победители будут опубликованы на&nbsp;сайте сервиса МТС Оплата
        до&nbsp;31 января 2026 года
      </>
}, {
  title: <>Как я узнаю, что стал победителем?</>,
  text: <>
        Победители публикуются на&nbsp;сайте МТС Оплата. Также начисление на&nbsp;Steam-аккаунт будет являться
        подтверждением выигрыша
      </>
}];

require("./faq.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./faq.tsx");